import { ChainId } from '@bscswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
  [ChainId.ROPSTEN]: '0x53C43764255c17BD724F74c4eF150724AC50a3ed',
  [ChainId.KOVAN]: '0x2cc8688C5f75E365aaEEb4ea8D6a480405A48D2A',
  [ChainId.RINKEBY]: '0x42Ad527de7d4e9d9d011aC45B31D8551f8Fe9821',
  [ChainId.GÖRLI]: '0x77dCa2C955b15e9dE4dbBCf1246B4B85b651e50e',
  [ChainId.BSC_MAINNET]: '0xe348b292e8eA5FAB54340656f3D374b259D658b8',
  [ChainId.BSC_TESTNET]: '0xe348b292e8eA5FAB54340656f3D374b259D658b8',
  [ChainId.POLYGON_MAINNET]: '0x11ce4B23bD875D7F5C6a31084f55fDe1e9A87507',
  [ChainId.POLYGON_TESTNET]: '0x75CeA8439e23269f79DB36caB245F0d6429bCe36',
  [ChainId.ARBITRUM_ONE]:'0x842eC2c7D803033Edf55E478F461FC547Bc54EB2'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
